export default __webpack_public_path__ + "28b8da373cc9c21395706fb7760f3346.png";